import { PlusIcon } from "lucide-react";
import React from "react";

/**
 * AddProductImagePlaceholder - A clickable placeholder component used to add new images to a product.
 * Displays a dashed border with a plus icon and descriptive text. Shows disabled state
 * when maximum images (10) are reached. Used in edit product bottom sheets.
 */

interface AddProductImagePlaceholderProps {
  type: string;
  className?: string;
  colorIcon?: string;
  onClick: () => void;
  disabled?: boolean;
}

export const AddProductImagePlaceholder: React.FC<AddProductImagePlaceholderProps> = ({
  type,
  className,
  colorIcon,
  onClick,
  disabled = false,
}) => (
  <button
    onClick={onClick}
    className={`${className} relative border border-[#e0e0e0] border-dashed
    ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
    flex items-center justify-center rounded-2xl overflow-hidden bg-[#f5f5f5]`}
  >
    <div className="text-center flex flex-col justify-center items-center">
      <PlusIcon
        width={24}
        height={24}
        color={colorIcon}
        stroke={disabled ? "#999" : colorIcon || "black"}
      />
      <p className="text-base font-semibold mt-2">
        {disabled ? "Max images reached (10)" : `Add ${type}`}
      </p>
    </div>
  </button>
);